/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-use-before-define, max-len */
import Axios, {
  AxiosInstance,
  AxiosResponse,
} from 'axios';
import { resumeParser } from './configuration';
/**
 * Requests
 */
class PlayServiceRequests {
  static client: PlayServiceRequests;

  axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: process.env.REACT_APP_PLAY_SERVICES_API,
    });
    this.axios.defaults.timeout = 35000;
  }

  static getInstance = () => {
    if (!PlayServiceRequests.client) {
      PlayServiceRequests.client = new PlayServiceRequests();
    }
    return PlayServiceRequests.client;
  };

  resumeParser = (payload: any) => this.axios.post(resumeParser.resumeParse, payload).then(
    (response: AxiosResponse<any>) => response.data,
  );
}

export default PlayServiceRequests;
